


export default function EtekafPlaceList({etecafId}) {
    return (
        <>
            <p>Etekaf Place List</p>
        </>
    )
}